import type { ColorComponent, RGBColor } from "@pdfking/math"

// "#rrggbb" as an RGBColor, opaque unless told its `alpha`
export const Hex = (hex: string, alpha = 1): RGBColor => {
  const channel = (at: number) => (parseInt(hex.slice(at, at + 2), 16) / 255) as ColorComponent
  return { alpha: alpha as ColorComponent, blue: channel(5), green: channel(3), red: channel(1) }
}
